import fabrica1 from '../images/fabrica-slide/fabrica-slide1.jpg'
import fabrica2 from '../images/fabrica-slide/fabrica-slide2.jpg'
import fabrica3 from '../images/fabrica-slide/fabrica-slide3.jpg'
import fabrica4 from '../images/fabrica-slide/fabrica-slide4.jpg'

export default [ fabrica1, fabrica2, fabrica3, fabrica4 ]